// On ocasion there's not a good key for a given rect component, this generates random enough hex codes to use as keys for elements

export const QuickKey = () => {
  let key = Math.floor(Math.random() * 100001) + 1;
  return key;
};

export default QuickKey;
